<template>
    <div>
        <h1 style="font-size: 24px; color: black;">处理财务数据</h1>
        <h2 style="font-size: 18px; color: darkorange;">1.变现产品配置</h2>
        <el-card shadow="never">
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <span> 应用： </span>
                    <el-select v-model="rsyncFcSetData.appId">
                        <el-option :key="-1" label="全部" :value="-1"></el-option>
                        <el-option
                                v-for="item in appList"
                                :label="item.appName"
                                :value="item.appId"
                                :key="item.appId">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="5">
                    <span> 媒体： </span>
                    <el-select v-model="rsyncFcSetData.mediaId" placeholder="请选择">
                        <el-option :key="-1" label="全部" :value="-1"></el-option>
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-date-picker
                            v-model="rsyncFcSetData.orgDate"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                </el-col>
                <el-col :span="8">
                    <span> 同步到：</span>
                    <el-date-picker
                            v-model="rsyncFcSetData.timeDate"
                            type="monthrange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :default-time="['00:00:00', '23:59:59']">
                    </el-date-picker>
                </el-col>
                <el-button type="primary" @click="rsyncFcSetting">同步</el-button>
            </el-row>
            <el-collapse v-model="activeNames">
                <el-collapse-item title="注意事项" name="1">
                    <div style="color: darkgreen">1. 按应用、媒体等条件将变现配置同步到其他月份</div>
                    <div></div>
                </el-collapse-item>
            </el-collapse>
        </el-card>
        <h2 style="font-size: 18px; color: darkorange;">2.同步业务汇总数据</h2>
        <el-card shadow="never">
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <span> 处理类型： </span>
                    <el-select v-model="rsyncBusinessData.lcType" placeholder="请选择">
                        <el-option :key="-1" label="拉取全部业务数据" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in lcTypes"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <span> 同步月份： </span>
                    <el-date-picker
                            v-model="rsyncBusinessData.monthDt"
                            type="month"
                            placeholder="选择月">
                    </el-date-picker>
                </el-col>
                <el-button type="primary" @click="rsyncBusiData">同步</el-button>
            </el-row>
        </el-card>
    </div>
</template>

<script>
    import {
        rsyncProductFcSetting, rsyncBusinessDataOperate
    } from "@/http/financialApi";
    import settingMix from '@/utils/mix/common-setting'
    import utils from "@/utils";

    export default {
        name: "HandleFinancialData",
        mixins: [settingMix],
        data() {
            return {
                mediaType: 1, //变现媒体
                needGetMedia: true,
                mediaObj: {},
                needGetApp: true,
                appList: [],
                activeNames: '1',
                lcTypes: {
                    1: "拉取业务变现收入",
                    2: "拉取业务投放消耗",
                    3: "拉取服务成本数据"
                },
                rsyncFcSetData: {
                    appId: -1,
                    mediaId: -1,
                    orgDate: '',
                    timeDate: ['', ''],
                },
                rsyncBusinessData: {
                    lcType: -1,
                    monthDt: ''
                }
            }
        },
        methods: {
            rsyncFcSetting() {
                let rsyncFcReq = {
                    appId: this.rsyncFcSetData.appId,
                    mediaId: this.rsyncFcSetData.mediaId,
                    orgDate: this.rsyncFcSetData.orgDate
                }
                rsyncFcReq.startDt = this.rsyncFcSetData.timeDate[0] === '' ? null : utils.DateUtil.formatDate(this.rsyncFcSetData.timeDate[0], "YYYY-MM-DD")
                rsyncFcReq.endDt = this.rsyncFcSetData.timeDate[1] === '' ? null : utils.DateUtil.formatDate(this.rsyncFcSetData.timeDate[1], "YYYY-MM-DD")
                rsyncProductFcSetting(rsyncFcReq).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '提交同步成功！',
                            center: true,
                            type: 'success'
                        })
                    } else {
                        this.$message({
                            message: '提交同步失败！'+resp.data.msg,
                            center: true,
                            type: 'error'
                        })
                    }
                })
            },
            rsyncBusiData() {
                rsyncBusinessDataOperate(this.rsyncBusinessData.lcType,
                utils.DateUtil.formatDate(this.rsyncBusinessData.monthDt, "YYYY-MM-DD")
                ).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '提交同步成功！',
                            center: true,
                            type: 'success',
                            duration: 5000
                        })
                    } else {
                        this.$message({
                            message: '提交同步失败！'+resp.data.msg,
                            center: true,
                            type: 'error',
                            duration: 5000
                        })
                    }
                })
            }
        },
        created() {

        },
    }

</script>

<style scoped>

</style>